import CustomSelect from 'components/shared/CustomSelect';
import FormGroup from 'components/shared/FormGroup';
import { useI18n } from 'hooks/useI18n';
import { ListItemStringValue } from 'interfaces/ui/ui-list-item';
import { useState } from 'react';
import {
  StyledInputs,
  StyledLabel,
  StyledOutput,
  StyledOutputs,
  StyledSection,
  StyledValue
} from './GenderCalculator.styled';

const GenderCalculator: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const data = [
    {
      role: 'Backend Developer',
      Men: 43.55142526964561,
      Women: 35.06880733944954
    },
    {
      role: 'Full-stack Developer',
      Men: 41.11195492405684,
      Women: 33.14545454545454
    },
    {
      role: 'Frontend Developer',
      Men: 38.06236017897091,
      Women: 30.42138364779874
    },
    {
      role: 'Mobile Developer',
      Men: 42.695595854922274,
      Women: 36.88157894736842
    },
    {
      role: 'Software Architect',
      Men: 54.55178907721281,
      Women: 50.03448275862069
    },
    {
      role: 'DevOps & Infrastructure & SRE',
      Men: 50.48601398601398,
      Women: 43.410714285714285
    },
    { role: 'SysAdmin', Men: 39.703125, Women: 38.375 },
    { role: 'Brand Design', Men: 39.395348837209305, Women: 31.95 },
    {
      role: 'Product Manager',
      Men: 55.49312714776632,
      Women: 46.25568181818181
    },
    {
      role: 'Data Analysis & BI',
      Men: 42.028517110266165,
      Women: 38.40425531914894
    },
    {
      role: 'QA & Testing Engineer',
      Men: 41.729729729729726,
      Women: 36.38888888888889
    },
    {
      role: 'Project Manager & Delivery Manager',
      Men: 55.48470588235294,
      Women: 45.01456310679612
    },
    {
      role: 'Data Scientist',
      Men: 42.22931034482759,
      Women: 38.644444444444446
    },
    {
      role: 'Data Engineer',
      Men: 46.73150684931507,
      Women: 44.7962962962963
    },
    {
      role: 'Engineering Management',
      Men: 62.71321695760598,
      Women: 50.945945945945944
    },
    {
      role: 'Tech Lead',
      Men: 58.80731364275668,
      Women: 54.85294117647059
    }
  ];

  const roles = data.map((d) => ({
    label: d.role,
    value: d.role
  }));

  const [currentWomenalary, setCurrentWomenalary] = useState<string>('--');
  const [currentMenalary, setCurrentMenalary] = useState<string>('--');

  const handleRoleChange = (selectedItem: ListItemStringValue): void => {
    const found = data.find((d) => d.role === selectedItem.value);

    if (found) {
      const { Women, Men } = found;

      setCurrentWomenalary(Women.toFixed(1));
      setCurrentMenalary(Men.toFixed(1));
    } else {
      setCurrentWomenalary('--');
      setCurrentMenalary('--');
    }
  };

  return (
    <StyledSection>
      <StyledInputs>
        <FormGroup label={t('gender.form.role')} forId="genderRole">
          <CustomSelect
            options={roles}
            id="genderRole"
            isSmall
            onChange={handleRoleChange}
            defaultValue={data[0].role}
          />
        </FormGroup>
      </StyledInputs>
      <StyledOutputs>
        <StyledOutput>
          <StyledLabel>{t('gender.form.women')}</StyledLabel>
          <StyledValue>
            €<span>{currentWomenalary}</span>K
          </StyledValue>
        </StyledOutput>
        <StyledOutput>
          <StyledLabel>{t('gender.form.men')}</StyledLabel>
          <StyledValue>
            €<span>{currentMenalary}</span>K
          </StyledValue>
        </StyledOutput>
      </StyledOutputs>
    </StyledSection>
  );
};

export default GenderCalculator;
